import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The No brown M&M's rule",
  "description": "",
  "published": "2012-01-10T00:00:00.000Z",
  "redirect_from": ["/blog/the-no-brown-mms-rule/swizec/3390"],
  "categories": "Git, Revision control, Tools, Uncategorized, Van Halen",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`There once was a band, let's call them `}<a parentName="p" {...{
        "href": "http://www.van-halen.com",
        "title": "Van Halen"
      }}>{`Van Halen`}</a>{`, who had a very long and complex contract for venues. Partly because they were famous and venues would do anything to get them, partly because people could literally die.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/01/300px-Van_Halen_-_Jump_2007-11-102.jpg",
        "alt": "Van Halen performs their song \"Jump\"...",
        "title": "Van Halen performs their song \"Jump\"..."
      }}></img></p>
    <p>{`The contract was full of useful things like "The floor should support such and such weight" and "We need power outlets there and there and there "`}</p>
    <p>{`In the middle of nowhere was a demand for `}<em parentName="p">{`a bowl of M&M's backstage, without any brown pieces`}</em>{`.`}</p>
    <p>{`An outlandish request, by flamboyant rockstars stretching their decadence? Not really, just a very good way to make sure the contract was followed to the letter and, you know, they'd survive the show. Find a brown piece - go check over the whole production. You `}<em parentName="p">{`will`}</em>{` find something wrong.`}</p>
    <p>{`With the current startup climate developers are the modern rockstars. We may not get all the groupies and we may be quite well behaved for the most part - but it's time we started making fun outlandish requests don't you think?`}</p>
    <p>{`Designers are usually seen as the extravagant bit of the startup world, getting all the cool toys, working from rooms filled with inspiration and mojo ... developers concern themselves much less with these things - give us a good set of monitors, free reign on our computer, some peace and quiet and we'll be happy.`}</p>
    <p>{`But when there are so many opportunities out there, you need a brown M&M so you don't end up wasting even a day at a company that doesn't quite live up to expectations.`}</p>
    <p>{`For me, the brown M&M is `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Revision_control",
        "title": "Revision control"
      }}>{`version control`}</a>{`.`}</p>
    <p>{`If a company isn't using git or mercurial, I can be pretty certain there will be other problems as well. Everything from a shoddy codebase, to expecting my physical presence before my brain has had a chance to boot in the morning.`}</p>
    <p>{`Usually the use of old-ish tools also correlates with a corporate feel to the company, which goes directly against `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/why-i-only-work-with-startups/swizec/2936"
      }}>{`my rule of only working with `}{`[`}{`small`}{`]`}{` startups`}</a>{`. Plus it usually means I won't be given freedom in choosing the best technology stack for the job, but will have something mandated from above.`}</p>
    <p>{`I could probably go on, but you can imagine the rest. Use of `}<a parentName="p" {...{
        "href": "http://subversion.apache.org/",
        "title": "Apache Subversion"
      }}>{`SVN`}</a>{` or, god forbid, nothing, is a deal breaker for me and it's the symptom I can discover very early in the process ... haven't gone so far as putting it in the contract yet.`}</p>
    <p>{`Do you use a brown M&M technique to assess potential clients?`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.fourhourworkweek.com/blog/2012/01/01/no-brown-mms-david-lee-roth-and-the-power-of-checklists/"
        }}>{`No Brown M&M's! David Lee Roth and the Power of Checklists`}</a>{` (fourhourworkweek.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://r.zemanta.com/?u=http%3A//www.guardian.co.uk/music/musicblog/2012/jan/04/valen-halen-david-lee-roth&a=69445001&rid=b1fa680b-accb-4c9c-9a28-6e4812ae6347&e=f775e713b9d76aa8a86b40cca9fd4251"
        }}>{`A classic interview with Van Halen`}</a>{` (guardian.co.uk)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.noisecreep.com/2011/11/30/van-halens-brown-M-Ms-rider-demand/"
        }}>{`Van Halen's 'No Brown M&Ms' Rider Demand Explained by Promoter`}</a>{` (noisecreep.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=b1fa680b-accb-4c9c-9a28-6e4812ae6347",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      